import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Dialog, InputBase } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import { X } from "lucide-react";
import { updateTwilioVoiceUrl } from "../../api/adminApi";

const UpdateVoiceUrlModal = ({
  open,
  setOpen,
  orgId,
  initialPhone = "",
  initialUrl = "",
  onUpdated,
}) => {
  const [phone, setPhone] = useState("");
  const [webhookUrl, setWebhookUrl] = useState("");
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return;
    setPhone(initialPhone || "");
    setWebhookUrl(initialUrl || "");
    setError(null);
    setLoader(false);
  }, [open, initialPhone, initialUrl]);

  const submit = async () => {
    setError(null);
    if (!phone.trim() || !webhookUrl.trim()) {
      setError("Phone number and webhook URL are required");
      return;
    }
    setLoader(true);
    try {
      await updateTwilioVoiceUrl({
        orgId,
        phone_number: phone.trim(),
        webhook_url: webhookUrl.trim(),
      });
      setOpen(false);
      if (onUpdated) onUpdated();
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.response?.data?.msg ||
          err?.message ||
          "Failed to update voice URL"
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      BackdropProps={{ style: { backgroundColor: "rgb(144,150,160,0.8)" } }}
    >
      <div className="px-8 py-6">
        <div className="relative mb-3">
          <div className="lg:text-[20px] text-[18px] font-semibold">
            Update voice URL
          </div>
          <div className="absolute top-0 right-0">
            <X
              className="w-[20px] text-gray-400 cursor-pointer"
              onClick={() => setOpen(false)}
            />
          </div>
        </div>
        {error && (
          <div className="text-red-500 text-[13px] font-semibold mb-2">
            <ErrorOutline sx={{ fontSize: 16 }} /> {error}
          </div>
        )}
        <div className="space-y-3">
          <InputBase
            placeholder="Phone number (+1…)"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            sx={{
              bgcolor: "white",
              border: "1px solid #E0E0E0",
              width: "100%",
              px: 2,
              py: 1,
              fontSize: "14px",
              borderRadius: "8px",
            }}
          />
          <InputBase
            placeholder="Webhook URL"
            value={webhookUrl}
            onChange={(e) => setWebhookUrl(e.target.value)}
            sx={{
              bgcolor: "white",
              border: "1px solid #E0E0E0",
              width: "100%",
              px: 2,
              py: 1,
              fontSize: "14px",
              borderRadius: "8px",
            }}
          />
        </div>
        <div className="flex justify-end gap-2 mt-5">
          <Button
            onClick={() => setOpen(false)}
            sx={{ textTransform: "none", color: "#6B7280" }}
          >
            Cancel
          </Button>
          <Button
            onClick={submit}
            disabled={loader}
            sx={{
              textTransform: "none",
              bgcolor: "#605BFF",
              color: "white",
              borderRadius: "8px",
              px: 2.5,
              "&:hover": { bgcolor: "#4F46E5" },
            }}
          >
            {loader ? (
              <CircularProgress size={18} sx={{ color: "white" }} />
            ) : (
              "Update"
            )}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default UpdateVoiceUrlModal;
